import Vue from 'vue';
import Config from 'rfp-storelocator/code/Scripts/Components/Config/config.js';
import locationIcon from 'rfp-storelocator/code/images/Components/StoreLocator/location.png';
import '@Themes/04_refapp/store-locator/index.scss';

Vue.use(Config, {
  locationIcon
});
